<template>
  <div v-show="tabs.components.length == 0 || $route.path == '/'">
    <counts></counts>
  </div>
  <div v-show="$route.path != '/'">
    <template v-for="item in tabs.components" :key="item.name">
      <div v-show="item.uid == tabs.selected">
        <component :is="item.name"></component>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import counts from "./counts/main";
import users from "./users/main";
import myHotels from "./myHotels/main";
import accounts from "./accounts/main";
import notifications from "./notification/main.vue";
import currencies from "./currencies/main";
import languages from "./languages/main";
import countries from "./countries/main";
import operators from "./operators/main";
import workers from "./workers/main";
import branchs from "./branchs/main";
import customers from "./customers/main";
import customerProviders from "./customerProviders/main";
import checkUser from "./checkUser/main";
import softwares from "./softwares/main";
import destinationTowns from "./destinationTowns/main";
import hotels from "./hotels/main";
import hotelDetail from "./hotels/detail";
import hotelGroups from "./hotelGroups/main";
import scans from "./tourscope/scans/main";
import localScans from "./tourscope/localScans/main";
import createListScanItems from "./tourscope/createListScanItems/main";
import operator from "./tourscope/operators/main";
import operatorCountries from "./tourscope/operatorCountries/main";
import departureCities from "./tourscope/departureCities/main";
import operatorDepartureCities from "./tourscope/operatorDepartureCities/main";
import operatorMatchReport from "./tourscope/operatorMatchReport/main";
import operatorHotels from "./tourscope/operatorHotels/main";
import searchMinPrices from "./tourscope/searchMinPrices/main";
import scanErrors from "./tourscope/scanErrors/main";
import providers from "./kolayrez/providers/main";
import kolayrezCountry from "./kolayrez/match/softwareCountry/main";
import kolayrezCurrencies from "./kolayrez/match/softwareCurrencies/main";
import kolayrezMarkets from "./kolayrez/match/providerMarkets/main";
import kolayrezCitizenships from "./kolayrez/match/providerCitizenships/main";
import kolayrezHotelNames from "./kolayrez/match/providerHotelNames/main";
import kolayrezAgencyOperators from "./kolayrez/match/providerAgencyOperators/main";
import kolayrezScanErrors from "./kolayrez/scanErrors/main.vue";
import kolayrezMails from "./kolayrez/mails/main.vue";
import confirmedDocument from "./kolayrez/confirmedDocuments/main.vue";
import PMSLogs from "./kolayrez/PMSLogs/main.vue";
import tempReservations from "./kolayrez/tempReservation/main.vue";
import CustomerProvidersLogs from "./kolayrez/customerProvidersLogs/main.vue";
import reservations from "./kolayrez/reservations/main";
import usingReport from "./reports/usingReport";
import schema from "./schema";
import arrayDiff from "./arrayDiff";
import squids from "./technicals/squids/main.vue";
import queues from "./technicals/queues/main.vue";
import dedicatedProxies from "./technicals/dedicatedProxies/main.vue";
import roomAvailibility from "./reSearch/roomAvailibility/main.vue";
import providerBasedReservations from "./reSearch/providerBasedReservations/main.vue";
import improve1 from "./reSearch/improve1/main.vue";
import mailWorkers from "./technicals/mailWorkers/main.vue";
import sednaReservationLogs from "./kolayrez/sednaReservationLogs/main.vue";
import test from "./test";
export default {
  name: "Home",
  components: {
    counts,
    users,
    myHotels,
    accounts,
    notifications,
    currencies,
    languages,
    countries,
    operators,
    reservations,
    workers,
    branchs,
    customers,
    customerProviders,
    checkUser,
    softwares,
    destinationTowns,
    hotels,
    hotelDetail,
    hotelGroups,
    scans,
    localScans,
    createListScanItems,
    operator,
    operatorCountries,
    departureCities,
    operatorDepartureCities,
    operatorMatchReport,
    operatorHotels,
    searchMinPrices,
    scanErrors,
    providers,
    kolayrezCountry,
    kolayrezCurrencies,
    kolayrezMarkets,
    kolayrezCitizenships,
    kolayrezHotelNames,
    kolayrezAgencyOperators,
    kolayrezScanErrors,
    PMSLogs,
    tempReservations,
    CustomerProvidersLogs,
    kolayrezMails,
    usingReport,
    schema,
    arrayDiff,
    squids,
    dedicatedProxies,
    queues,
    roomAvailibility,
    providerBasedReservations,
    improve1,
    mailWorkers,
    sednaReservationLogs,
    confirmedDocument,
    test,
  },
  computed: {
    ...mapState(["tabs"]),
  },
};
</script>

<style></style>
